<template>
  <text-input-element
    :disabled="disabled"
    :validation-rules="getValidationRules"
    :value="value"
    label="Mot de passe"
    type="password"
    @input="$emit('input', $event)"
  ></text-input-element>
</template>

<script>
import TextInputElement from "./base/TextInputElement";

export default {
  name: "PasswordInputElement",
  components: {
    TextInputElement
  },
  data: () => ({
    errorMessage: ''
  }),
  mounted() {
    if (this.isInReadOnlyMode) {
      this.$emit('input', '***********')
    }
  },
  watch: {
    /**
     * Fills the input with asterixes when the user switches to Read only mode.
     * Clears the input when the user switches to edit mode.
     * @param boolean
     * @return {default.watch}
     */
    isInReadOnlyMode: function (boolean) {
      return boolean ? this.$emit('input', '***********') : this.$emit('input', '');
    }
  },
  props: {
    value: {
      required: true
    },
    validationRules: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    getValidationRules() {
      return this.validationRules.length ? `${this.validationRules}` : '';
    },
    isInReadOnlyMode() {
      return this.$isReadOnly();
    }
  }

}
</script>

